import { socialCrawlerApiClient } from '../client';

export function getSources() {
  return socialCrawlerApiClient.get('/source/list').then(({ data }) => data);
}

export function getSuggestedSources(entityType, entityId) {
  return socialCrawlerApiClient
    .get(`/suggested/sources/${entityType}/${entityId}`)
    .then(({ data }) => data);
}

export function getSourceReviews(sourceId, harvesterId, params) {
  return socialCrawlerApiClient
    .get(`/get/reviews/${sourceId}/${harvesterId}`, { params })
    .then(({ data }) => data);
}

export function deleteSourceReviews(documentIds) {
  return socialCrawlerApiClient
    .post('/delete/reviews', {
      documentIds,
    })
    .then(({ data }) => data);
}

export function getSourceHistory(harvesterId) {
  return socialCrawlerApiClient
    .get(`/get/history/${harvesterId}`)
    .then(({ data }) => data);
}

export function updateSourceVerifiedStatus(data) {
  return socialCrawlerApiClient
    .post('/verify/undo/url', data)
    .then((res) => res.data);
}

export function getDomainMappingList() {
  return socialCrawlerApiClient.get('/domain/list').then(({ data }) => data);
}

export function getEntityVerificationSources() {
  return socialCrawlerApiClient.get('/sources').then(({ data }) => data);
}

export function getAutoSelectSources(domain) {
  return socialCrawlerApiClient
    .get('/autoSelect/source', {
      params: {
        domain,
      },
    })
    .then(({ data }) => data);
}

export function addSources(data) {
  return socialCrawlerApiClient
    .post('/add/sources', data)
    .then((res) => res.data);
}

export function deleteSources(harvesterIds) {
  return socialCrawlerApiClient
    .post('/delete/urls', {
      harvesterIds,
    })
    .then(({ data }) => data);
}
